import { BrMenu } from '@govbr-ds/react-components';
import { useNavigate } from 'react-router-dom';

import { environment } from '../../../environments/environment';
import { returnBaseUrl } from '../../../utils/baseURL';
import PGRMLogo from './../../../assets/PGRM-logo-with-text-color.png';

function Menu() {
  const SITE_ENVIRONMENT = environment.environment;
  const navigate = useNavigate();

  const urlBase = globalThis.location.origin;
  const demonstraLink = `${urlBase}/demonstra/html/`;

  const diefLink = `${urlBase}/dief`;

  const onPGRMClick = () => {
    const url = returnBaseUrl(SITE_ENVIRONMENT === 'local' ? 'des' : SITE_ENVIRONMENT);

    globalThis.location.href = url;
  };

  const subMenuContent = [
    {
      icon: 'home',
      label: 'Página Inicial',
      onClick: () => (globalThis.location.href = `${diefLink}/`),
    },
    {
      icon: 'file-alt',
      label: 'Titular ou Arrendatário',
      onClick: () => (globalThis.location.href = `${diefLink}/titular-ou-arrendatario`),
    },
    {
      icon: 'hand-holding-usd',
      label: 'Primeiro Adquirente',
      onClick: () => (globalThis.location.href = `${diefLink}/primeiro-adquirente`),
    },
    {
      icon: 'gavel',
      label: 'Arrematação em Hasta Pública',
      onClick: () => (globalThis.location.href = `${diefLink}/hasta-publica`),
    },
  ];

  return (
    <div className='menu-content'>
      <BrMenu
        closable
        data={[
          {
            divider: true,
            icon: 'home',
            label: 'Página Inicial da Plataforma',
            onClick: () => onPGRMClick(),
          },
          {
            divider: true,
            label: 'DIEF-CFEM',
            icon: 'pen',
            submenu: subMenuContent,
          },
          {
            divider: true,
            label: 'Arrecadação-CFEM',
            icon: 'money-bill-wave',
            onClick: () => navigate('/'),
          },
          {
            divider: true,
            icon: 'file-contract',
            label: 'Resoluções',
            submenu: [
              {
                label: 'Resolução ANM nº 156, 8 de Abril de 2024',
                onClick: () =>
                  globalThis.open(
                    'https://anmlegis.datalegis.net/action/ActionDatalegis.php?acao=abrirTextoAto&link=S&tipo=RES&numeroAto=00000156&seqAto=000&valorAno=2024&orgao=DC/ANM/MME&cod_modulo=566&cod_menu=8303',
                    '_blank',
                    'noopener'
                  ),
              },
              {
                label: 'Resolução ANM nº 200, 27 de Março de 2025',
                onClick: () =>
                  globalThis.open(
                    'https://anmlegis.datalegis.net/action/ActionDatalegis.php?acao=abrirTextoAto&link=S&tipo=RES&numeroAto=00000200&seqAto=000&valorAno=2025&orgao=DC/ANM/MME&codTipo=&desItem=&desItemFim=&cod_modulo=566&cod_menu=8303',
                    '_blank',
                    'noopener'
                  ),
              },
              {
                label: 'Resolução ANM nº 241, 30 de Junho de 2026',
                onClick: () =>
                  globalThis.open(
                    'https://anmlegis.datalegis.net/action/ActionDatalegis.php?acao=abrirTextoAto&link=S&tipo=RES&numeroAto=00000241&seqAto=000&valorAno=2026&orgao=DC/ANM/MME&cod_modulo=351&cod_menu=8731',
                    '_blank',
                    'noopener'
                  ),
              },
            ],
          },
          {
            divider: true,
            icon: 'calendar-day',
            label: 'Eventos',
            submenu: [
              {
                label:
                  'Webinar DIEF-CFEM: Nova Resolução, Sistema de Declaração e Transparência na Gestão Mineral - 18/09/2025',
                onClick: () => globalThis.open('https://enc.serpro.gov.br/5bc824c9', '_blank', 'noopener'),
                keepMenuActive: true,
              },
            ],
          },
          {
            icon: 'info',
            label: 'Manual PGRM',
            onClick: () => globalThis.open(demonstraLink, '_blank', 'noopener'),
            divider: true,
          },
          {
            icon: 'question',
            label: 'Guia Fácil DIEF-CFEM',
            onClick: () =>
              globalThis.open(
                'https://www.gov.br/anm/pt-br/centrais-de-conteudos/guia-facil/guia-facil-dief-cfem',
                '_blank',
                'noopener'
              ),
            divider: true,
          },
        ]}
        externalLinks={[
          {
            label: 'Cadastro para Requerimentos - ANM',
            link: 'https://www.gov.br/anm/pt-br/assuntos/exploracao-mineral/Cadastro-para-Requerimentos',
          },
        ]}
        id='main-navigation'
        systemLogoUrl={PGRMLogo}
        systemName='PGRM'
      />
    </div>
  );
}

export default Menu;
